import { render } from "./DragDrop.vue?vue&type=template&id=0df2eaf6&ts=true"
import script from "./DragDrop.vue?vue&type=script&lang=ts"
export * from "./DragDrop.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__